const coproModalDialogWrapper = document.querySelector('#copro-modal-wrapper');
const coproModalCloseButton = document.querySelector('#copro-modal-close-button');

const coproModalWrapper = {

	registerEvents: () => {
		coproModalCloseButton.addEventListener('click', coproModalWrapper.handleClose());
		document.addEventListener('keydown', function (event) {
			if (event.key === "Escape") {
				if (coproModalDialogWrapper.style.display == 'block') {
					coproModalWrapper.handleClose();
				}
			}
		});
	},

	handleOpen: () => {
		//console.log('open modal');

		if (coproModalDialogWrapper.style.display == 'none') {
			coproModalDialogWrapper.style.display = 'block';
			coproModalDialogWrapper.classList.add('open');
			coproModalDialogWrapper.setAttribute('aria-hidden', 'false');
			coproModalDialogWrapper.setAttribute('aria-expanded', 'true');
			//coproModalDialogWrapper.querySelector('textarea').focus();
		}

	},

	handleClose: () => {
		//console.log('closeModal');

		if (coproModalDialogWrapper.style.display == 'block') {
			coproModalDialogWrapper.style.display = 'none';
			coproModalDialogWrapper.classList.remove('open');
			coproModalDialogWrapper.setAttribute('aria-hidden', 'true');
			coproModalDialogWrapper.setAttribute('aria-expanded', 'false');
		}
	},

	init: () => {

		coproModalWrapper.registerEvents();

		if (!coproModalDialogWrapper) return;

		if (typeof coproModalDialogWrapper != 'undefined' && coproModalDialogWrapper != null) {
			coproModalCloseButton.onclick = function (e) {
				coproModalWrapper.handleClose();
			};
			coproModalDialogWrapper.onclick = function (e) {
				e.stopPropagation();
			};
		}

	},

};

export default coproModalWrapper;